import {Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {Observable, Subscription} from 'rxjs';
import {SubscriptionSiteForm} from '../../models/site-form';
import {ServerForm} from '../../../shared/models/servers';
import {StatusToOffComponent} from '../modal-status-to-off/status-to-off.component';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../../reducers';
import {SiteGetInfoService} from '../../services/site-get-info.service';
import {L10N_LOCALE, L10nLocale, L10nTranslationService} from 'angular-l10n';
import { Timezone} from '../../../shared';
import * as fromShared from '../../../shared/reducers';
import {skipWhile} from 'rxjs/operators';

@Component({
  selector: 'storever-site-edit',
  templateUrl: './site-edit.component.html',
  styleUrls: ['./site-edit.component.scss']
})
export class SiteEditComponent implements OnInit, OnDestroy {

  dataConfig: DataConfig;
  content: Observable<SubscriptionSiteForm>;
  @Output() saveForm = new EventEmitter<Object>();
  private sub$: Subscription;
  private subscriptions = [];
  public isVideoProduct: boolean;
  servers$: Observable<ServerForm[]>;
  @ViewChild('statusToOff' , {static: false}) statusToOff: StatusToOffComponent;

  constructor(private store: Store<fromSites.AppState>,
              private siteGetInfoService: SiteGetInfoService ,
              private translation: L10nTranslationService ,
              @Inject(L10N_LOCALE) public locale: L10nLocale) {
  }

  ngOnInit(): void {
    this.dataConfig.form.disable();
    this.dataConfigContentPatchForm();
    this.timezoneValueChangesMap();
  }



  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }



  dataConfigContentPatchForm(formPath?: string[]): void {
    this.content = this.dataConfig.content;
    this.sub$ = this.content.subscribe(sub => {
      if (formPath) {
        this.dataConfig.form.get(formPath).patchValue(sub[formPath[0]]);
      } else {
        this.dataConfig.form.patchValue(sub);
      }
      this.setStatusPresentationInDetailIfOff();
    });
    this.subscriptions.push(this.sub$);
  }

  setStatusPresentationInDetailIfOff(): void {
    // console.log(this.dataConfig)
    if (this.dataConfig.form.get(['subscription', 'status', 'id']).value === 1) {
      this.dataConfig.groupConfigs.groupConfigs[1].config[2].presentation = 'detail';
    } else {
      this.dataConfig.groupConfigs.groupConfigs[1].config[2].presentation = 'edit';
    }
  }

  /**
   * - Value from FormGroup
   * - Update/patch part of the object
   * @param apiNames
   */
  save(apiNames: string[]): void {
    // console.log(apiNames)
    if (!this.openModalIfStatusOffAndEditable(apiNames)) {
      this.saveEmit(apiNames);
    }
  }

  saveEmit(apiNames: string[]): void {
    // console.log(apiNames , this.dataConfig.form)
    const resp = this.dataConfig.form.get(apiNames[1]).value;
    this.saveForm.emit({ type: 'multiSubscription' , api: apiNames, data: resp });
  }

  undo(formPath: string[]): void {
    this.dataConfig.form.get(formPath).reset();
    this.dataConfigContentPatchForm(formPath);
  }

  isStatusEditable(): boolean {
    return this.dataConfig.form.get(['subscription', 'status', 'id']).value === 1
      && this.dataConfig.groupConfigs.groupConfigs[1].config[2].presentation === 'edit'
  }

  openModalIfStatusOffAndEditable(apiNames: string[]): boolean {
    if (this.isStatusEditable() && apiNames[1] === 'subscription') {
      this.statusToOff.open();
      this.sub$ = this.statusToOff._send.subscribe(response => {
        if (response) {
          this.setStatusPresentationInDetailIfOff();
          this.saveEmit(apiNames);
        }
      });
      this.subscriptions.push(this.sub$);
      return true;
    }
    return false;
  }

  timezoneValueChangesMap(): void {
    this.dataConfig.form.get(['site', 'timezone']).valueChanges.subscribe((timezone: Timezone) => {
      if (timezone.ianaCode) {
        this.mapTimeZone(timezone);
      }
    });
    this.servers$ = this.store.pipe(select(fromShared.selectors.getServer));
  }

  // TODO: if used more than once create a service
  mapTimeZone(selectedTimeZone: Timezone): void {
    this.store.pipe(
      select(fromShared.selectors.getTimezonesByIanaCode, selectedTimeZone.ianaCode),
      skipWhile((data: Timezone[]) => !data)
    ).subscribe(res => {
      if (res[0]) {
        this.dataConfig.form.get(['site', 'timezone']).patchValue(res[0], { onlySelf: true, emitEvent: false })
      }
    });

  }

  isOrderOpened(): Observable<boolean> {
    return this.siteGetInfoService.isOrderOpened()
  }

  get isStatusOff$(): Observable<boolean> {
    return this.siteGetInfoService.isStatusOff()
  }
}
